"use client";

import {
  Button,
  ButtonProps,
  Empty,
  Icon,
  IconProps,
} from "@stone-payments/jade";

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, "className"> & {
  icon?: IconProps["use"];
  title: string;
  message: string;
  action?: Omit<ButtonProps, "size"> & {
    text: string;
  };
};

export const Feedback = ({ icon, title, message, action, ...rest }: Props) => {
  return (
    <div
      className="m-auto flex h-full w-full max-w-120 flex-col items-center justify-center gap-6 text-center"
      {...rest}
    >
      {icon ? <Icon use={icon} size="xlarge" color="low" /> : null}
      <Empty title={title} message={message} />
      {action ? (
        <Button size="large" {...action}>
          {action.text}
        </Button>
      ) : null}
    </div>
  );
};
